import { MoreVert } from '@mui/icons-material'
import { Box, Menu, MenuItem } from '@mui/material'
import React, { Dispatch, Fragment, MouseEvent, SetStateAction, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useStyles } from './styles'

interface IRowMenu {
  currentId: string
  setCurrentId: Dispatch<SetStateAction<string>>
  rowId: string
  editRoutePath?: string
  detailRoutePath?: string
  handleDeleteButton?: (e: MouseEvent<any, any>, id: string) => void
}

interface IMenuState {
  open: boolean
  anchorEl: HTMLElement | null
}

const RowMenu: React.FC<IRowMenu> = ({
  currentId,
  setCurrentId,
  rowId,
  detailRoutePath,
  editRoutePath,
  handleDeleteButton,
}) => {
  const [menuState, setMenuState] = useState<IMenuState>({ open: false, anchorEl: null })

  const classes = useStyles({ color: 'red' })
  const history = useHistory()

  const menuId = `menu-options-${currentId}`
  const buttonId = `options-button-${currentId}`

  const handleOpenOptions = (event: MouseEvent<HTMLElement>, id: string) => {
    setMenuState({ open: true, anchorEl: event.currentTarget })
    setCurrentId(id)
  }

  const handleCloseOptions = () => setMenuState({ open: false, anchorEl: null })

  const handleEdit = (id: string) => {
    if (editRoutePath != 'undefined') {
      history.push(`${editRoutePath}/${id}`)
    }
  }

  const handleDetails = (id: string) => {
    if (detailRoutePath != 'undefined') {
      history.push(`${detailRoutePath}/${id}`)
    }
  }

  return (
    <>
      <Box key={buttonId} onClick={(event) => handleOpenOptions(event, rowId)}>
        <MoreVert className={classes.tableIcon} />
      </Box>

      <Menu
        id={menuId}
        keepMounted
        sx={{ boxShadow: 'none' }}
        open={menuState.open}
        anchorEl={menuState.anchorEl}
        onClose={handleCloseOptions}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        {editRoutePath && <MenuItem onClick={() => handleEdit(currentId)}>Editar</MenuItem>}
        {handleDeleteButton && <MenuItem onClick={(e) => handleDeleteButton(e, currentId)}>Deletar</MenuItem>}
        {detailRoutePath && <MenuItem onClick={(e) => handleDetails(currentId)}>Detalhes</MenuItem>}
      </Menu>
    </>
  )
}

export default RowMenu
